import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2TelInputModule } from 'ng2-tel-input';

import { PhoneviewerComponent } from '../pages/phoneviewer/phoneviewer.component';



@NgModule({
  declarations: [PhoneviewerComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    Ng2TelInputModule,CommonModule
  ],
  exports: [PhoneviewerComponent]
})
export class SharedModule { }
